import { createApp } from "vue";
import App from "./App.vue";
import "./styles/tokens.css";
import "./styles/global.css";

createApp(App).mount("#app");
